import { Redirect, Route, RouteComponentProps, RouteProps, useHistory } from 'react-router-dom';
import { useAuthContext } from '../../modules/login/AuthContext';
import useSharedEntitystore from '../../stores/SharedEntities/sharedEntities.store';
import PATHS from '../routes.const';

export type PublicRouteProps = {
  disableRedirectWhenLogged?: boolean;
} & RouteProps;

const PublicRoute = ({
  component: Component,
  render,
  disableRedirectWhenLogged,
  ...props
}: PublicRouteProps) => {
  const { loggedin, redirectPath } = useAuthContext();
  const setPreviousUrl = useSharedEntitystore((state) => state.setPreviousUrl);
  const history = useHistory();

  const publicPaths = Object.values(PATHS.public);

  const path = publicPaths.some((publicPath) => publicPath.path === redirectPath)
    ? '/'
    : redirectPath;

  const notLoggedInRender = (renderProps: RouteComponentProps) => {
    if (Component) {
      return <Component {...renderProps} />;
    }

    if (render) {
      return render(renderProps);
    }
  };

  if (disableRedirectWhenLogged) {
    return <Route exact {...props} render={(renderProps) => notLoggedInRender(renderProps)} />;
  }

  return (
    <Route
      exact
      {...props}
      render={(renderProps) => {
        const { slug } = renderProps.match.params;

        if (renderProps.location.pathname.includes('share') && loggedin && slug) {
          setPreviousUrl(renderProps.location.pathname);
          history.push(`/${slug}/showroom`);
          return;
        }
        return !loggedin ? notLoggedInRender(renderProps) : <Redirect to={path} push={false} />;
      }}
    />
  );
};

export default PublicRoute;
